import HelsanaSwiper from './Classes/HelsanaSwiper';

import ResponsiveTablesLight from "./Classes/ResponsiveTablesLight";
import Accordion from './Classes/Accordion';
import Highchart from '../node_modules/highcharts/highcharts'
import DrawHighchart from './Classes/DrawHighcharts';
import TabsDropdown from './Classes/TabsDropdown';
import TableCharts from './Classes/TableCharts';
import CountUpper from './Classes/CountUpper';
import Anchor from "./Classes/Anchor.js";
import TitleHeightEqualizer from "./Classes/TitleHeightEqualizer"
// Initialize on document ready

var accordionInstance = null;

var responsiveTableInstance = null;


//window.addEventListener("DOMContentLoaded", function () {
window.addEventListener("page_event_load", function () {
  const hswiper = new HelsanaSwiper();

  const titleHeightEqualizer = new TitleHeightEqualizer(
    '.lc-columns.calculated-height-of-titles-charts',
    '.lc-chart__title'
  );


  new TabsDropdown();
  new CountUpper();

  new TableCharts();
  new Anchor();

  new ResponsiveTablesLight({
    tableComponentSelector: '.lc-component--table',
    tableContainerSelector: '.ns-table-container',
    tableSelector: '.lc-component--table table'
  });

  new ResponsiveTablesLight({
    tableComponentSelector: '.kfc-table-wrapper',
    tableContainerSelector: '.kfc-table-wrapper',
    tableSelector: '.kfc-table-wrapper table'
  });

  new DrawHighchart();


  accordionInstance = new Accordion({
    accordions: '.lc-accordion__inner-head',
    pxCorrectionMobile: 110,
    pxCorrectionDesktop: 105,
    mobileBreakpoint: 1025
  });
});

window.addEventListener('note_event_load', evt => {
  // console.log("note loaded event");
  document.body.classList.add("note-open");

  new ResponsiveTablesLight({
    tableComponentSelector: '.lc-component--table',
    tableContainerSelector: '.ns-table-container',
    tableSelector: '.lc-component--table table'
  });
});


window.addEventListener('note_unloaded', evt => {
  //console.log("note unloaded event");
  document.body.classList.remove("note-open");
});
